import { defineSlotRecipe } from '@chakra-ui/react/styled-system';

import { rem } from '../themeUtils';

export const multiselectSlotRecipe = defineSlotRecipe({
  className: 'multiselect',
  slots: ['control', 'trigger', 'overlay', 'tagsBlock', 'placeholderText', 'indicatorGroup', 'indicator'],
  base: {
    control: {
      position: 'relative',
      width: '100%',
    },
    trigger: {
      position: 'absolute',
      inset: 0,
      display: 'block',
      background: 'background/primary',
      borderWidth: '1',
      borderColor: 'border/strong',
      borderRadius: '4',
      color: 'input/text/inputValue',
      width: '100%',
      cursor: 'pointer',
      textAlign: 'start',
      userSelect: 'none',
      focusVisibleRing: 'inside',
      _disabled: {
        background: 'background/disabled',
        color: 'text/disabled',
        cursor: 'not-allowed',
      },
      _invalid: {
        borderColor: 'border/error',
      },
      _readOnly: {
        background: 'background/disabled',
        cursor: 'default',
      },
    },
    overlay: {
      position: 'relative',
      display: 'flex',
      alignItems: 'center',
      paddingInlineStart: '12',
      paddingInlineEnd: '48',
    },
    tagsBlock: {
      display: 'flex',
      flex: '1 0 0',
      flexWrap: 'wrap',
      alignItems: 'center',
      alignContent: 'center',
      gap: '8',
      minWidth: 0,
    },
    placeholderText: {
      flex: '1 0 0',
      minWidth: 0,
      height: '24',
      display: 'inline-flex',
      alignItems: 'center',
      color: 'input/text/inputValue',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      '&[data-placeholder]': {
        color: 'text/secondary',
      },
    },
    indicatorGroup: {
      display: 'flex',
      alignItems: 'center',
      gap: '8',
      position: 'absolute',
      insetInlineEnd: 0,
      top: 0,
      height: '48',
      paddingInlineEnd: '16',
      paddingInlineStart: '8',
      pointerEvents: 'none',
      '& > button': {
        pointerEvents: 'auto',
      },
    },
    indicator: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: 'icon/secondary',
      _disabled: {
        color: 'icon/disabled',
      },
      _readOnly: {
        color: 'icon/on-disabled',
      },
    },
  },

  variants: {
    constrained: {
      true: {
        overlay: {
          overflow: 'hidden',
        },
        tagsBlock: {
          flexWrap: 'nowrap',
        },
      },
      false: {},
    },
    size: {
      lg: {
        overlay: {
          minHeight: '48',
          paddingBlock: rem(11),
        },
        trigger: {
          textStyle: 'body/lg/regular',
        },
        placeholderText: {
          textStyle: 'body/lg/regular',
          lineHeight: rem(24),
        },
      },
      md: {
        indicatorGroup: {
          height: '40',
        },
        overlay: {
          minHeight: '40',
          paddingBlock: rem(7),
          '&:has([data-slot="tag"])': {
            paddingInlineStart: rem(7),
          },
        },
        trigger: {
          textStyle: 'body/md/regular',
        },
        placeholderText: {
          textStyle: 'body/md/regular',
          lineHeight: rem(20),
        },
      },
    },
  },
  compoundVariants: [
    {
      constrained: true,
      size: 'lg',
      css: {
        overlay: {
          height: '48',
          minHeight: '48',
          paddingBlock: '12',
        },
      },
    },
    {
      constrained: true,
      size: 'md',
      css: {
        overlay: {
          height: '40',
          minHeight: '40',
          paddingBlock: '8',
        },
      },
    },
  ],
  defaultVariants: {
    constrained: false,
    size: 'lg',
  },
});

export default multiselectSlotRecipe;
